module.exports = __webpack_public_path__ + "static/media/2 (4).4e90278d.jpg";